import { withQueryString } from "@/lib/api/api-helpers";
import { baseApi } from "@/redux/api/base-api";
import { IHttpResponse } from "@/types/api-response";

type CommonSearchParams = {
  name?: string;
  filter?: string;
  skip?: number;
  limit?: number;
};

export interface IAirport {
  country?: string;
  name?: string;
  iata_code: string;
  city_name?: string;
  latitude?: number | null;
  longitude?: number | null;
}

export interface ICountry {
  id?: string | number;
  iso: string;
  iso3?: string;
  name?: string;
  phone_code?: string;
}
export interface ICity {
  id?: string | number;
  iso: string;
  iso3?: string;
  name?: string;
  phone_code?: string;
  lat?: number;
  lng?: number;
}

export interface IHotelLocation {
  id: number;
  name: string;
  code: number;
  type: "Hotel" | "City";
  city_code: number;
  country_code: string;
  star_category?: number;
  country_name: string;
  rank?: number;
}

export const airportApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    searchAirport: builder.query<IHttpResponse<IAirport[]>, CommonSearchParams>({
      query: (params) => ({
        url: withQueryString("/public/common/airport", params),
        method: "GET",
      }),
    }),
    searchCountry: builder.query<IHttpResponse<ICountry[]>, CommonSearchParams>({
      query: (params) => ({
        url: withQueryString("/public/common/country", params),
        method: "GET",
      }),
    }),
    searchCity: builder.query<IHttpResponse<ICity[]>, CommonSearchParams & { country_id?: string[] }>({
      query: (params) => ({
        url: withQueryString("/public/common/city", params),
        method: "GET",
      }),
    }),
    searchHotelLocation: builder.query<
      IHttpResponse<IHotelLocation[]>,
      CommonSearchParams
    >({
      query: (params) => ({
        url: withQueryString("/public/common/location-hotel", params),
        method: "GET",
      }),
    }),
  }),
});

export const {
  useSearchAirportQuery,
  useLazySearchAirportQuery,
  useSearchCountryQuery,
  useLazySearchCountryQuery,
  useSearchHotelLocationQuery,
  useSearchCityQuery,
  useLazySearchCityQuery,
  useLazySearchHotelLocationQuery,
} = airportApi;
